import { Component, Input } from '@angular/core';

@Component({
  selector: 'sky-mobile-info',
  templateUrl: './mobile-info.component.html',
  styleUrls: ['./mobile-info.component.scss'],
})
export class MobileInfoComponent {
  @Input() brand: string | null | undefined = undefined;
  @Input() phoneModel: string | null | undefined = undefined;
  @Input() imei: string | null | undefined = undefined;
}
